import { render, staticRenderFns } from "./DeviceWorkShiftMonitor.vue?vue&type=template&id=eb45a8be&scoped=true"
import script from "./DeviceWorkShiftMonitor.vue?vue&type=script&lang=js"
export * from "./DeviceWorkShiftMonitor.vue?vue&type=script&lang=js"
import style0 from "./DeviceWorkShiftMonitor.vue?vue&type=style&index=0&id=eb45a8be&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb45a8be",
  null
  
)

export default component.exports